import { render, staticRenderFns } from "./FieldItemValue.vue?vue&type=template&id=31c1a0ef&"
import script from "./FieldItemValue.vue?vue&type=script&lang=js&"
export * from "./FieldItemValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports